import { restClient } from '../config/restClient'

const endpoint = interviewRequestId => `/api/company/v2/interview_requests/${interviewRequestId}/offers`

export const getInterviewRequestOffers = async interviewRequestId => {
  const response = await restClient(endpoint(interviewRequestId), {
    method: 'GET',
  })
  return response.data
}

export const postInterviewRequestOffer = async (interviewRequestId, data) => {
  const response = await restClient(endpoint(interviewRequestId), {
    method: 'POST',
    data,
  })
  return response.data
}
